<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal id="sharecropper-land-modal" size="lg" title="Sharecropper Land Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-8">
            <label for="crop_affected_id">Crop Affected <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.crop_affected_id" v-validate="'required'" id="crop_affected_id" name="crop_affected_id" class="form-control form-control-sm">
              <option selected :value="''">Select Crop Affected</option>
              <option v-for="(crop_affected, index) in crop_affecteds" v-bind:value="crop_affected.id" :key="index">Mouza: {{ crop_affected.land.mouza.mouza_desc }},  Plot: {{ crop_affected.land.plot_no }}, Crops Affected: ({{ crop_affected.crop_category.crop_category_desc}})</option>
            </select>
            <div class="invalid-feedback">Please select valid crop</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="rp_serial">RP Serial</label>
            <input type="number" v-model="sharecropper_land.rp_serial" v-validate="'numeric'" id="rp_serial" name="rp_serial" class="form-control form-control-sm" placeholder="RP serial"/>
            <div class="invalid-feedback">RP serial is required</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="name">Sharecropper Name <span class="c-required">*</span></label>
            <input type="text" v-model="sharecropper_land.name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="name" name="name" class="form-control form-control-sm" placeholder="Employee name"/>
            <div class="invalid-feedback">Please enter sharecropper name</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="father_husband_name">Father/Husband Name <span class="c-required">*</span></label>
            <input type="text" v-model="sharecropper_land.father_husband_name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="father_husband_name" name="father_husband_name" class=" form-control form-control-sm" placeholder="Father/Husband name"/>
            <div class="invalid-feedback">Please enter Father/Husband name.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="mother_name">Mother Name <span class="c-required">*</span></label>
            <input type="text" v-model="sharecropper_land.mother_name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="mother_name" name="mother_name" class=" form-control form-control-sm" placeholder="Mother's name"/>
            <div class="invalid-feedback">Please enter Mother's name.</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="gender_id">Gender <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.gender_id" v-validate="'required'" id="gender_id" name="gender_id" class="form-control form-control-sm">
              <option selected disabled :value="''">Select Gender</option>
              <option v-for="(gender, index) in genders" :key="index" :value="gender.id">{{ gender.id }} : {{ gender.gender_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select a gender.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="dob">Date of Birth <span class="c-required">*</span></label>
            <datepicker v-model="sharecropper_land.dob" v-validate="'required'" id="dob" name="dob" :format="customDateDob" :disabled-dates="disabledDates" placeholder="Date of Birth"></datepicker>
            <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('dob')">Date of birth is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="nid" class="col-form-label col-form-label-sm">NID/Passport/Birth Certificate No. <span class="c-required">*</span></label>
            <div class="row m-0">
              <div class="col-4 p-0">
                <select class="form-control form-control-sm" v-model="sharecropper_land.id_type">
                  <option value="N">NID</option>
                  <option value="P">Passport</option>
                  <option value="B">Birth</option>
                </select>
              </div>
              <div class="col-8 p-0">
                <input type="text" v-model="sharecropper_land.nid" v-validate="{ required: true, regex: /^[a-zA-Z0-9_.-]*$/,min: 6 }" id="nid" name="nid" class="form-control form-control-sm" placeholder="Enter NID/Birth/Passport number"/>
              </div>
              <div class="invalid-feedback">Please enter a valid number.</div>
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="mobile">Mobile No. <span class="c-required">*</span></label>
            <input type="number" v-model="sharecropper_land.mobile" v-validate="'required|length:11'" id="mobile" name="mobile" class="form-control form-control-sm" placeholder="Mobile number"/>
            <div class="invalid-feedback">Please enter mobile number.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="village_id">Village <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.village_id" v-validate="'required'" id="village_id"  name="village_id" @change="getAddress(sharecropper_land.village_id)" class="form-control form-control-sm">
              <option selected disabled :value="''">Select a village</option>
              <option v-for="(village, index) in villages" :key="index" :value="village.id">{{ village.id }} : {{ village.village_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select Village.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="occupation_id"> Main Occupation <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.occupation_id"
                    v-validate="'required'" id="occupation_id"name="occupation_id" class="form-control form-control-sm">
              <option selected disabled :value="''">Select an occupation</option>
              <option v-for="(occupation, index) in occupations" :key="index" :value="occupation.id">{{ occupation.id }} : {{ occupation.occupation_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select occupation.</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="religion_id">Religion <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.religion_id" v-validate="'required'" id="religion_id" name="religion_id" class="form-control form-control-sm">
              <option selected disabled :value="''">Select a Religion</option>
              <option v-for="(religion, index) in religions" :key="index" :value="religion.id">{{ religion.id }} : {{ religion.religion_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select a religion.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="education_id">Education <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.education_id" v-validate="'required'" id="education_id"  name="education_id" class="form-control form-control-sm">
              <option selected :value="''">Select a Education</option>
              <option v-for="(education, index) in educations" :key="index" :value="education.id">{{ education.id }} : {{ education.education_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select education.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="marital_status_id">Marital Status <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.marital_status_id" v-validate="'required'" id="marital_status_id"name="marital_status_id" class="form-control form-control-sm">
              <option selected disabled :value="''">Select an occupation</option>
              <option v-for="(marital_status, index) in marital_statuses" :key="index" :value="marital_status.id">{{ marital_status.id }} : {{ marital_status.marital_status_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select marital status.</div>
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="area_manager_id">Area Manager <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.area_manager_id" v-validate="'required'" id="area_manager_id" name="area_manager_id" class="form-control form-control-sm" @change="getSurveyConducted(sharecropper_land.area_manager_id)">
              <option selected disabled :value="''">Select Area Manager</option>
              <option v-for="(area_manager, index) in area_managers" :key="index" :value="area_manager.id">{{ area_manager.id }} : {{ area_manager.name }}</option>
            </select>
            <div class="invalid-feedback">Please select area manager.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="area_manager_date">Area Manager Date  <span class="c-required">*</span></label>
            <datepicker v-model="sharecropper_land.area_manager_date" v-validate="'required'" id="area_manager_date" name="area_manager_date" :format="customDateAreaManager" placeholder="Area Manager Date"></datepicker>
            <div class="text-danger" v-if="errors.has('area_manager_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">Area manager date required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="survey_worker_id">Survey Conducted By <span class="c-required">*</span></label>
            <select v-model="sharecropper_land.survey_worker_id" v-validate="'required'" id="survey_worker_id" name="survey_worker_id" class="form-control form-control-sm">
              <option selected disabled :value="''">Select Worker who conduct Survey</option>
              <option v-for="(survey_worker, index) in survey_workers" :key="index" :value="survey_worker.id">{{ survey_worker.id }} : {{ survey_worker.name }}</option>
            </select>
            <div class="invalid-feedback">
              Please select Worker.
            </div>
          </div>

        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="survey_date">Survey Conducted Date <span class="c-required">*</span></label>
            <datepicker v-model="sharecropper_land.survey_date" v-validate="'required'" id="survey_date" name="survey_date" :format="customDateSurvey" placeholder="Survey Date"></datepicker>
            <div class="text-danger" v-if="errors.has('survey_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">Survey date required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="address">Present Address <span class="c-required">*</span></label>
            <textarea v-model="sharecropper_land.address" v-validate="'required'" id="address" name="address" class="form-control form-control-sm" placeholder="Enter address"></textarea>
            <div class="invalid-feedback">Please enter present address</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="area_land_cultivated">Area of Land Cultivate <span class="c-required">*</span></label>
            <input type="text" v-model="sharecropper_land.area_land_cultivated" v-validate="'required'" id="area_land_cultivated" name="area_land_cultivated" class="form-control form-control-sm" placeholder="Enter area of land cultivate"/>
            <div class="invalid-feedback">Please enter area of land cultivate also in number format</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="annual_income">Annual Income <span class="c-required">*</span></label>
            <input type="number" v-model="sharecropper_land.annual_income"  v-validate="{ required: true, max: 15, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/ }" id="annual_income" name="annual_income" class="form-control form-control-sm" placeholder="Enter annual income"/>
            <div class="invalid-feedback">Please enter annual income also in number format</div>
          </div>
          <div class="col-md-4 col-sm-4 col-lg-4">
            <label for="remarks">Remarks</label>
            <input v-model="sharecropper_land.remarks" id="remarks" name="remarks" type="text" class="form-control form-control-sm"/>
          </div>
        </div>

        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Sharecropper </b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Sharecropper</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('sharecropper-land-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import http from "@state/http";
  import moment from "moment";
  import Datepicker from "vuejs-datepicker";
  import Multiselect from "vue-multiselect";

  export default {
    props: ["sharecropper_land","btn_edit"],

    components: {Datepicker},
    data() {
      return {
        crop_affecteds: [],
        genders: [],
        villages: [],
        unions: [],
        mouzas: [],
        upazilas: [],
        districts: [],
        divisions: [],
        religions: [],
        occupations: [],
        area_sections: [],
        area_managers: [],
        survey_workers: [],
        educations: [],
        marital_statuses: [],
        validation_errors: {},
        show: false,
        checkedData: true,
        disabledDates: {
          from: new Date(Date.now())
        },
      };
    },
    mounted() {
      this.getCodes();
    },
    methods: {
      customDateDob(date) {
        this.sharecropper_land.dob = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      customDateSurvey(date) {
        this.sharecropper_land.survey_date = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      customDateAreaManager(date) {
        this.sharecropper_land.area_manager_date = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      customDateAppointment(date) {
        this.sharecropper_land.appointment_date = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
       save() {
         this.$validator.validate().then(valid => {
          if (valid) {
             http.post("api/sharecropper-lands", this.sharecropper_land)
                    .then(response => {
                      if (!response.data.error) {
                        this.$emit("resetForm");
                        this.$bvToast.toast(response.data.message, {
                          title: "Success",
                          noAutoHide: true,
                          variant: "success"
                        });
                        this.$bvModal.hide("sharecropper-land-modal");
                        this.$emit("getPersonalSharecropperLand");
                      }

                      if (response.data.error == true) {
                        this.$bvToast.toast(response.data.message, {
                          title: "Error",
                          autoHideDelay: 5000,
                          variant: "danger"
                        });
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                      this.show = true;
                      this.hide();
                    });
          }
        });
      },
       update() {
         this.$validator.validate().then(valid => {
          if (valid) {
            http.put("api/sharecropper-lands/" + this.sharecropper_land.sharecropper_land_id, this.sharecropper_land)
                    .then(response => {
                      if (!response.data.error) {
                        this.$bvModal.hide("sharecropper-land-modal");
                        this.$bvToast.toast(response.data.message, {
                          title: "Success",
                          noAutoHide: true,
                          variant: "success"
                        });
                        this.$emit("getPersonalSharecropperLand");
                      }

                      if (response.data.error == true) {
                        this.$bvToast.toast(response.data.message, {
                          title: "Error",
                          autoHideDelay: 5000,
                          variant: "danger"
                        });
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                      this.show = true;
                      this.hide();
                      this.$bvToast.toast("Update Failed", {
                        title: "Error",
                        autoHideDelay: 5000,
                        variant: "danger"
                      });
                    });
          }
        });
      },
       getCodes() {
         let ses_id = this.$route.params.ses_id;
         http.get("api/sharecropper-land/codes/" + ses_id).then(response => {
          if (!response.error) {
            let data = response.data;
            this.crop_affecteds = data.crop_affecteds;
            this.genders = data.genders;
            this.villages = data.villages;
            this.unions = data.unions;
            this.districts = data.districts;
            this.upazilas = data.upazilas;
            this.mouzas = data.mouzas;
            this.divisions = data.divisions;
            this.religions = data.religions;
            this.occupations = data.occupations;
            this.area_sections = data.area_sections;
            this.area_managers = data.area_managers;
            this.educations = data.educations;
            this.marital_statuses = data.marital_statuses;
          }
        });
      },
       getSurveyConducted(area_manager_id) {
        this.survey_workers = this.area_managers.find(
            area_manager => area_manager.id == area_manager_id
        ).survey_workers;
      },
       getAddress(village_id) {
         let village = this.villages.find(v => v.id == village_id);

         let mouza = this.mouzas.find(m => m.id == village.mouza_id);
         this.sharecropper_land.mouza_id = mouza.id;

         let union = this.unions.find(u => u.id == mouza.union_id);
         this.sharecropper_land.union_id = union.id;

         let upazila = this.upazilas.find(d => d.id == union.upazila_id);
         this.sharecropper_land.upazila_id = upazila.id;

         let district = this.districts.find(d => d.id == upazila.district_id);
         this.sharecropper_land.district_id = district.id;

         let division = this.divisions.find(dv => dv.id == district.division_id);
         this.sharecropper_land.division_id = division.id;

        },
       hide() {
          setTimeout(() => {
            this.show = false;
          }, 5000);
        },
    },
  };
</script>
<style>
  .vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
  }
  .c-required{
    color: red;
  }
</style>
